const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? "https://aligndesk.dropyourbusiness.com" 
  : "";

export default API_BASE_URL;
